import { render, staticRenderFns } from "./ValidationRuleEdit.vue?vue&type=template&id=17c86818"
import script from "./ValidationRuleEdit.vue?vue&type=script&lang=js"
export * from "./ValidationRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports